<template>
    <form action="" method="POST" @submit.prevent="submit" novalidate autocomplete="off">
        <div class="input-wrapper form-input-text input-has-full-border">
            <div class="code-wrapper">
                <input v-for="n in 6" :key="n" type="text" maxlength="1" :name="'code-'+n" class="required-input full-border" required>
            </div>

            <form-input-error
                v-if="errors && errors.code" 
                :error="errors.code[0]"
                centered
            ></form-input-error>
        </div>

        <v-button label="Senden" type="submit" size="lg" position="center"></v-button>

        <p class="after-form text-default text-centered text-color-default">Benötigen Sie Unterstützung? <strong><a href="/kontakt" target="_blank">Kontaktieren Sie uns!</a></strong></p>
    </form>
</template>

<script>
    export default {
        data() {
            return {
                errors: {},
                token: null
            }
        },
        mounted() {
            let uri = new URI(location.href)

            this.token = uri.pathname().replace("/vivira-code/", "")

            let inputs = document.getElementsByClassName("required-input")

            inputs = [...inputs]

            inputs.forEach((element, index) => {
                element.addEventListener('keyup', (event) => {
                    var key = event.keyCode || event.charCode

                    if( key == 8 ) {
                        if(index !== 0) {
                            inputs[index - 1].focus()
                        }
                    } else if(index !== 5) {
                        inputs[index + 1].focus()
                    }
                })
            })
        },
        methods: {
            submit() {
                let formData = {
                    code: '',
                    token: this.token
                }

                $(this.$el)
                    .serializeArray()
                    .forEach(({ name, value }) => {
                        formData['code'] += value
                    })

                axios
                    .post('/api/vivira-code', formData, {
                        headers: {
                            'Accept-Language': 'de'
                        }
                    })
                    .then((e) => {
                        
                    })
                    .catch((e) => {
                        console.log(e.response)
                        this.errors = e.response.data.errors
                        Vuemit.fire('Button--sending-failed', true)
                    }) 
            }
        }
    }
</script>
